import { createFeatureSelector, createSelector } from '@ngrx/store';
import { getFeatureFlagEnabledByName } from '../../utils/feature-flag.util';
import { FeatureFlagState } from '../reducers/feature-flag.reducer';

export const createFeatureFlagsState = createFeatureSelector<FeatureFlagState>('featureFlag');

// hub feature flags
export const selectFeatureFlagHubState = createSelector(createFeatureFlagsState, (state) => {
  return state?.hub;
});
export const selectHubFeatureFlagsProcessed = createSelector(selectFeatureFlagHubState, (state) => {
  return state ? state.processed : null;
});
export const selectHubFeatureFlags = createSelector(selectFeatureFlagHubState, (state) => state?.response);
export const selectHubIsDisplayingMaintenanceBanner = createSelector(
  selectHubFeatureFlags,
  (featureFlags) => featureFlags && getFeatureFlagEnabledByName(featureFlags, 'AWEE429PLMaintenance')
);
export const selectHubIsOptInEnabled = createSelector(
  selectHubFeatureFlags,
  (featureFlags) => featureFlags && getFeatureFlagEnabledByName(featureFlags, 'AWEE395ExpressLaneOptInToggle')
);
export const selectIsMobileAppEnabled = createSelector(
  selectHubFeatureFlags,
  (featureFlags) => featureFlags && getFeatureFlagEnabledByName(featureFlags, 'AWEE761MobileAppPlacementToggle')
);

export const selectIs100KLoanBannerEnabled = createSelector(
  selectHubFeatureFlags,
  (featureFlags) => featureFlags && getFeatureFlagEnabledByName(featureFlags, 'FIN2808100kLoanBanner')
);

export const selectHubIsRefiFirstEnabled = createSelector(
  selectHubFeatureFlags,
  (featureFlags) => featureFlags && getFeatureFlagEnabledByName(featureFlags, 'FIN2755RefinanceOfferFirstInCarousel')
);

export const selectHubIsDebtConsolidationEnabled = createSelector(
  selectHubFeatureFlags,
  (featureFlags) => featureFlags && getFeatureFlagEnabledByName(featureFlags, 'FIN2677DebtConsolidation')
);

export const selectHubIsOptInBannerEnabled = createSelector(
  selectHubFeatureFlags,
  selectHubIsOptInEnabled,
  (featureFlags, isOptInEnabled) =>
    featureFlags && isOptInEnabled && getFeatureFlagEnabledByName(featureFlags, 'AWEE395ExpressLaneOptInBanner')
);


// offer feature flags
export const selectFeatureFlagOfferState = createSelector(createFeatureFlagsState, (state) => {
  return state?.offers;
});
export const selectOfferFeatureFlagsProcessed = createSelector(selectFeatureFlagOfferState, (state) => {
  return state ? state.processed : null;
});
export const selectOfferFeatureFlags = createSelector(selectFeatureFlagOfferState, (state) => state?.response);
export const selectOfferIsDisplayingMaintenanceBanner = createSelector(
  selectOfferFeatureFlags,
  (featureFlags) => featureFlags && getFeatureFlagEnabledByName(featureFlags, 'AWEE429PLMaintenance')
);
export const selectOfferIsOptInEnabled = createSelector(
  selectOfferFeatureFlags,
  (featureFlags) => featureFlags && getFeatureFlagEnabledByName(featureFlags, 'AWEE395ExpressLaneOptInToggle')
);
export const selectOfferIsOptInBannerEnabled = createSelector(
  selectOfferFeatureFlags,
  selectOfferIsOptInEnabled,
  (featureFlags, isOptInEnabled) =>
    featureFlags && isOptInEnabled && getFeatureFlagEnabledByName(featureFlags, 'AWEE395ExpressLaneOptInBanner')
);

export const selectDisablePaymentsIsEnabled = createSelector(
  selectHubFeatureFlags,
  (featureFlags) => featureFlags && getFeatureFlagEnabledByName(featureFlags, 'AWEE366DisablePaymentsAndCollections')
);

export const selectOfferIsDebtConsolidationEnabled = createSelector(
  selectOfferFeatureFlags,
  (featureFlags) => featureFlags && getFeatureFlagEnabledByName(featureFlags, 'FIN2677DebtConsolidation')
);

export const selectIsTelephonyOutageBannerEnabled = createSelector(
  selectHubFeatureFlags,
  (featureFlags) => featureFlags && getFeatureFlagEnabledByName(featureFlags, 'CV3643ServiceAlertPhoneOutage')
);

export const selectIsCardHoldTimesBannerEnabled = createSelector(
  selectHubFeatureFlags,
  (featureFlags) => featureFlags && getFeatureFlagEnabledByName(featureFlags, 'CV3643ServiceAlertLongHoldTimesCard')
);

export const selectIsLoanHoldTimesBannerEnabled = createSelector(
  selectHubFeatureFlags,
  (featureFlags) => featureFlags && getFeatureFlagEnabledByName(featureFlags, 'CV3643ServiceAlertLongHoldTimesLoan')
);

export const selectIsLoanTelephonyOutageBannerEnabled = createSelector(
  selectHubFeatureFlags,
  (featureFlags) => featureFlags && getFeatureFlagEnabledByName(featureFlags, 'CV3643ServiceAlertPhoneOutageLoan')
);

export const selectIsCardTelephonyOutageBannerEnabled = createSelector(
  selectHubFeatureFlags,
  (featureFlags) => featureFlags && getFeatureFlagEnabledByName(featureFlags, 'CV3643ServiceAlertPhoneOutageCard')
);


export const selectOfferIsRefiFirstEnabled = createSelector(
  selectOfferFeatureFlags,
  (featureFlags) => featureFlags && getFeatureFlagEnabledByName(featureFlags, 'FIN2755RefinanceOfferFirstInCarousel')
);

